import React from 'react'
import { withStyles, Dialog, DialogContent, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import SmileIcon from '@material-ui/icons/SentimentSatisfiedAlt'
import Button from 'components/Button';
import Tr from 'translations/Translations';
import Title from 'components/Title';

const style = theme => ({
	root: {

	},
	icon: {
		fontSize: theme.components.icon.fontSize,
	},
	content: {
		textAlign: 'center',
		'&>*': {
			marginBottom: theme.spacing(2)
		}
	}
})

function WelcomeTutorial({
	classes,
	open,
	onClick
}) {

	return (
		<Dialog open={open}>
			<DialogContent className={classes.content}>
				<SmileIcon className={classes.icon} />
				<Title>
					{Tr('tutorial_t_0')}
				</Title>
				<Typography variant='body1'>
					{Tr('tutorial_d_0')}
				</Typography>
				<Button
					variant='contained'
					onClick={onClick}
					fullWidth
				>
					{Tr('start')}
				</Button>
			</DialogContent>
		</Dialog>
	)
}

WelcomeTutorial.propTypes = {
	classes: PropTypes.any,
	open: PropTypes.bool,
	onClick: PropTypes.func,
}

WelcomeTutorial.defaultProps = {
	onClick: () => {}
}

export default withStyles(style)(WelcomeTutorial);